import { action, computed } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { PostQuery, PostMutation } from 'apps/aggregator/gql';
import { PostModel, PostApp } from 'apps/aggregator/app';

export class PostPageAppManager extends AppManager {
  static registryName = 'PostPageAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('postPage', PostApp);
    this.variables = new Variables({
      slug: () => this.params.get('slug'),
    });
    this.variables.onChange(['slug'], this.NewSlug);
  }

  @computed get loading() {
    return this.queries.get('postPage')?.loading;
  }

  @action NewSlug = () => {
    const q = new PostQuery(this, {
      queryKey: 'postPage',
      onSysErr: this.onSysErr,
    });
    q.process(postPage => PostModel.Load(postPage), this.PostPageUpdate);
    q.query();
  };

  @action PostPageUpdate = postModel => {
    this.postPage = postModel;
  };

  @action onSysErr = () => {
    // TODO
  };

  @action UpdatePost = (input, options) => {
    const update = new PostMutation(input);
    update.process(post => PostModel.Load(post));
    update.setCallbacks(options);
    update.mutate();
  };
}
